import "./Skill.css";

function Skill({ darkMode }) {
    const skillGroups = [
        {
            title: "Languages",
            skills: [
                [
                    "Python",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg",
                ],
                [
                    "Java",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg",
                ],
                [
                    "C",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/c/c-original.svg",
                ],
                [
                    "C++",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg",
                ],
                [
                    "Kotlin",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kotlin/kotlin-original.svg",
                ],
                [
                    "JavaScript",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
                ],
                [
                    "TypeScript",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
                ],
                [
                    "Swift",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/swift/swift-original.svg",
                ],
                [
                    "SQL",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/azuresqldatabase/azuresqldatabase-original.svg",
                ],
            ],
        },
        {
            title: "Frameworks & Technologies",
            skills: [
                [
                    "React",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
                ],
                [
                    "Next.js",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg",
                    true,
                ],
                [
                    "Three.js",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/threejs/threejs-original.svg",
                    true,
                ],
                [
                    "Firebase",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
                ],
                [
                    "MySQL",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg",
                ],
            ],
        },
        {
            title: "Tools & Platforms",
            skills: [
                [
                    "GitHub",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg",
                    true,
                ],
                [
                    "VS Code",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vscode/vscode-original.svg",
                ],
                [
                    "IntelliJ",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/intellij/intellij-original.svg",
                ],
                [
                    "AWS",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
                ],
                [
                    "Jupyter",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jupyter/jupyter-original-wordmark.svg",
                ],
                [
                    "Vercel",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vercel/vercel-original.svg",
                    true,
                ],
                [
                    "Docker",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg",
                ],
                [
                    "Postman",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg",
                ],
                [
                    "Netlify",
                    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/netlify/netlify-original.svg",
                ],
            ],
        },
    ];

    return (
        <section
            className={`skills-section ${darkMode ? "dark" : ""}`}
            id="skill"
        >
            <div className="skills-container">
                <span className="skills-tag">TECH STACK</span>

                <h1>Technologies I Work With</h1>

                {skillGroups.map((group, index) => (
                    <div className="skills-group" key={index}>
                        <h2>{group.title}</h2>

                        <div className="skills-grid">
                            {group.skills.map(([name, icon, invert], idx) => (
                                <div className="skill-card" key={idx}>
                                    <img
                                        src={icon}
                                        alt={name}
                                        className={invert ? "invert-icon" : ""}
                                    />

                                    <span>{name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Skill;
